import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CampaignPage from './pages/CampaignPage';
import CharacterEditPage from './pages/CharacterEditPage';
import PartyViewPage from './pages/PartyViewPage';
import AdminPage from './pages/AdminPage';

function App() {
  return (
    <BrowserRouter>
        <div className="min-h-screen bg-dnd-dark text-dnd-fg">
        <main className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/:slug" element={<CampaignPage />} />
            <Route path="/:slug/party" element={<PartyViewPage />} />
            <Route path="/:slug/character/:id" element={<CharacterEditPage />} />
            {/* WHY: Only one character route needed. React Router v6 specificity would cause
                /:slug/character/new to shadow /:slug/character/:id, making id undefined
                and triggering infinite loading in CharacterEditPage. */}
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
